<script setup>
import { computed, ref } from "vue";

import LinksLimitBanner from "@Components/banners/LinksLimit.vue";
import FormSelector from "@Components/tinyurl/shortener/FormSelector.vue";
import SingleForm from "@Components/tinyurl/shortener/single-form/Form.vue";
import BulkForm from "@Components/tinyurl/shortener/bulk-form/Form.vue";

import useLegacyStore from "@Composables/useLegacyStore";
import useLimit from "@Composables/useLimit";

import LIMITS_TYPE from "@Constants/limits-type";
import { OVERAGE_STATUS } from "@Constants/overage-status";

const { getters } = useLegacyStore();
const linksLimit = useLimit(LIMITS_TYPE.LINKS_PER_MONTH);

const selectedForm = ref("single");

const canBulkCreateTinyUrl = computed(() => getters.canBulkCreateTinyUrl);
const currentSubscription = computed(() => getters.getUserCurrentSubscription);
const isAccountUsageEnabled = computed(() => getters.isAccountUsageEnabled);
const isUserSubscribed = computed(() => getters.isUserSubscribed);
const isLinksBannerVisible = computed(() => {
  if (!isAccountUsageEnabled.value) {
    return false;
  }

  if (
    !isUserSubscribed.value ||
    currentSubscription.value?.isLegacy
  ) {
    return linksLimit.isHardLimitReached.value;
  }

  return (
    linksLimit.isHardLimitReached.value &&
    !linksLimit.hasStatus(OVERAGE_STATUS.ALL_ENABLE)
  );
});

function setForm(form) {
  selectedForm.value = form;
}
</script>

<template>
  <div
    class="shortener-form"
    data-test-id="dashboard_create_tinyurl_form"
    role="dialog"
  >
    <LinksLimitBanner v-if="isLinksBannerVisible" />
    <FormSelector
      v-if="canBulkCreateTinyUrl"
      class="shortener-form__selector"
      :selected-form="selectedForm"
      @on-form-select="setForm"
    />
    <SingleForm v-if="selectedForm === 'single'" />
    <BulkForm v-else />
  </div>
</template>

<style lang="scss" scoped>
@use "@tinyurldev/tu-ui-vue/scss/settings/spacing.scss" as spacing;

.shortener-form {
  &__selector {
    margin-bottom: spacing.$xxs;
  }
}
</style>
